export default {
  inserted(el: HTMLElement) {
    // Check if element is an input component. If so, only mask the input element
    if (el.classList.contains('v-text-field')) {
      el.querySelector('input')?.classList.add('fs-exclude');
    } else {
      el.classList.add('fs-exclude');
    }
  }
};
